import { useTheme } from '@app/providers/theme-provider'
import type { Post } from '@entities/post'
import { classNames } from '@shared/lib/classNames'
import { dateToTimeString } from '@shared/lib/dateToTimeString/dateToTimeString'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import { Typography } from 'antd'
import { useCallback, useRef } from 'react'
import type { Formats, HeaderProps, SlotInfo } from 'react-big-calendar'
import { Calendar as RBCCalender, dayjsLocalizer, Views } from 'react-big-calendar'
import { CustomTag } from '../custom-tag/custom-tag'
import './styles/styles.scss'
import { CustomRBCToolbar } from './toolbar'
import type { RBCEvent } from './types'

const { Text } = Typography

const localizer = dayjsLocalizer(dayjs)

interface RBCCalendarProps {
    events: RBCEvent[]
    onChange: ({ startDate, endDate }: { startDate: Date; endDate: Date }) => void
    onClick: (post: Post) => void
    onSelectDay: (data: SlotInfo) => void
}

export const RBCCalendar = ({ events, onChange, onClick, onSelectDay }: RBCCalendarProps) => {
    const { theme } = useTheme()

    const Header = ({ label }: HeaderProps) => (
        <Typography.Text strong style={{ textTransform: 'capitalize' }}>
            {label}
        </Typography.Text>
    )

    const formats: Formats = {
        eventTimeRangeFormat: (props: { start: Date }) => {
            return dateToTimeString(props.start)
        },
        weekdayFormat: 'dddd'
    }

    const onChangeHandler = (
        range:
            | Date[]
            | {
                  start: Date
                  end: Date
              }
    ) => {
        if (Array.isArray(range)) {
            onChange({
                startDate: range[0],
                endDate: dayjs(range[range.length - 1])
                    .endOf('day')
                    .toDate()
            })
        } else {
            onChange({ startDate: range.start, endDate: range.end })
        }
    }

    // const menuItems: MenuProps['items'] = useMemo(
    //     () => [
    //         {
    //             key: '1',
    //             label: <Space>Снять с очереди</Space>
    //         },
    //         {
    //             key: '2',
    //             danger: true,
    //             label: (
    //                 <Space>
    //                     <DeleteOutlined /> Удалить
    //                 </Space>
    //             )
    //         }
    //     ],
    //     []
    // )

    const calendarRef = useRef<RBCCalender<RBCEvent>>(null)
    const handleSelectEvent = (event: RBCEvent) => {
        onClick(event.post)
    }

    const onSelectSlot = useCallback((slotInfo: SlotInfo) => {
        onSelectDay(slotInfo)
    }, [])

    return (
        <div className={classNames('', {}, [theme])}>
            <RBCCalender
                localizer={localizer}
                // eventPropGetter={eventPropGetter}
                events={events}
                enableAutoScroll={true}
                ref={calendarRef}
                popup={true}
                selectable
                onSelectSlot={onSelectSlot}
                formats={formats}
                style={{ height: '99vh' }}
                doShowMoreDrillDown
                defaultView={Views.MONTH}
                onSelectEvent={handleSelectEvent}
                messages={{
                    showMore: (count: number) => `more ${count}`
                }}
                components={{
                    toolbar: (props) => <CustomRBCToolbar {...props} />,
                    // Сделать меню по готовности апи
                    // eventWrapper: (props) => <CustomTag>{props.children}</CustomTag>,
                    // eventContainerWrapper: (props) => <div>{props.children}</div>,
                    event: ({ event }) => {
                        let title = ''
                        let timeToTop = ''
                        if (event.post?.advertisingInfo?.budget) {
                            title =
                                event.post?.postType?.name || event.post?.advertisingInfo?.budget > 0
                                    ? 'Рекламный'
                                    : 'Коллаборация'
                            const publishDate = dayjs(event.post.publishDate)
                            const timeTop =
                                event.post?.keepOnTopHours && publishDate.add(event.post?.keepOnTopHours, 'hour')
                            timeToTop = timeTop ? timeTop.format('HH:mm') : ''
                        } else {
                            title = event.post?.postType?.name || 'Базовый'
                        }
                        const time = dayjs(event.post.publishDate).format('HH:mm')
                        return (
                            <CustomTag color={event.post.postType?.color} container>
                                <Text>
                                    {time}
                                    {timeToTop && ` - ${timeToTop}`}
                                </Text>
                            </CustomTag>
                        )
                    },
                    month: {
                        header: Header
                    }
                }}
                onRangeChange={onChangeHandler}
            />
        </div>
    )
}
